import { useState } from 'react';
import { DictionaryDataFetchWrapper } from '../wrappers/DictionaryDataFetchWrapper';
import { DataFetchFunction } from '../types/ProgressTypes';
import { useDevice } from '../../model/DeviceContext';


export const useWasteCodeData = (onComplete?: () => void) => {
    const [showProgress, setShowProgress] = useState(false);
    const [fetchDataFunction, setFetchDataFunction] = useState<DataFetchFunction | null>(null);
    const { isTrial } = useDevice(); // Get isTrial from context when hook is used
    const sheetName = "SL01 Kody Odpadów";

    const fetchWasteCodeData = () => {
        const dataFetch = DictionaryDataFetchWrapper.wrapDictionaryWasteCodeDataFetch(sheetName, isTrial);
        setFetchDataFunction(() => dataFetch);
        setShowProgress(true);
    };

    const resetProgress = () => {
        setShowProgress(false);
        setFetchDataFunction(null);
    };

    const handleProgressComplete = (wasSuccess: boolean) => {
        resetProgress();
        if (wasSuccess && onComplete) {
            onComplete();
        }
    };

    return {
        showProgress,
        fetchDataFunction,
        fetchWasteCodeData,
        resetProgress,
        handleProgressComplete
    };
};